import { FC } from "react";
import { observer } from "mobx-react-lite";
import appStore from "../../../stores/appStore";

const AboutCompany: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-2xl font-semibold">О компании</h2>
      <div className="bg-white rounded-2xl shadow p-6">
        <p className="mb-4">
          Компания «КЦ Авто» была основана в 2008 году. За время нашей работы
          мы завоевали уважение партнёров и заработали авторитет среди наших
          клиентов. На сегодняшний день «КЦ Авто» предлагает более 20 000
          наименований как оригинальных запасных частей, так и продукцию от
          ведущих мировых производителей, таких как: CTR, FEBEST, LYNXauto,
          ASVA, AMD, SSANG SHIN, SK encar T7, DAEWOO, MANDO, KYB и другие.
        </p>
        <p className="mb-4">
          «КЦ Авто» — это сеть магазинов запчастей и автохимии, работающая с
          2008 года и насчитывающая десятки магазинов во многих крупных городах,
          среди которых{" "}
          {appStore.cities.map((i, index) => (
            <span key={i.name}>
              {i.name}
              {appStore.cities.length - 1 > index ? ", " : ""}
            </span>
          ))}
        </p>
        <p>
          Мы стремимся удовлетворить любые потребности наших клиентов в выборе
          автозапчастей, предлагая широкий ассортимент и квалифицированную
          помощь в подборе. Наша команда всегда готова предоставить
          профессиональную консультацию и помочь вам найти именно ту деталь,
          которая необходима вашему автомобилю. Добро пожаловать в сеть
          магазинов «КЦ Авто», мы рады видеть вас в наших торговых точках!
        </p>
      </div>

      <h2 className="text-2xl font-semibold">Оплата и доставка</h2>
      <div className="bg-white rounded-2xl shadow p-6">
        <p className="mb-4">
          На сайте «КЦ Авто» вы можете ознакомиться с нашим ассортиментом
          автозапчастей и оформить предварительный резерв на интересующие вас
          товары. Для вашего удобства предусмотрена возможность выбора ближайшей
          торговой точки из нашей сети.
        </p>
        <p className="mb-4">
          Обращаем ваше внимание, что оплата и получение зарезервированных
          товаров производятся непосредственно в выбранном вами магазине «КЦ
          Авто». Вы сможете приехать в магазин в удобное для вас время в течение
          срока действия резерва (стандартный срок — 24 часа), оплатить заказ
          любым доступным в магазине способом и забрать свои автозапчасти.
        </p>
        <p>
          Возврат и гарантийное обслуживание приобретенных в сети магазинов «КЦ
          Авто» товаров осуществляются в соответствии с действующим
          законодательством Российской Федерации, в частности, Законом РФ «О
          защите прав потребителей». Подробную информацию об условиях возврата и
          гарантии вы можете получить у сотрудников наших магазинов.
        </p>
      </div>
    </div>
  );
};

export default observer(AboutCompany);